import { FirebaseApp, initializeApp } from 'firebase/app';
import { getGlobalConfig } from 'lib/config/globalConfig';

const {
  FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_DATABASE_URL,
  FIREBASE_PROJECT_ID,
  FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID,
} = getGlobalConfig();

const firebaseConfig = {
  apiKey: FIREBASE_API_KEY,
  authDomain: FIREBASE_AUTH_DOMAIN,
  databaseURL: FIREBASE_DATABASE_URL,
  projectId: FIREBASE_PROJECT_ID,
  appId: FIREBASE_APP_ID,
  measurementId: FIREBASE_MEASUREMENT_ID,
};

function app(): FirebaseApp | undefined {
  if (FIREBASE_APP_ID === undefined && process.env.NODE_ENV !== 'test') {
    console.warn('warning: firebase not initialized, FIREBASE_APP_ID is undefined');
    return undefined;
  }
  return initializeApp(firebaseConfig);
}

export default app;
